import React from 'react';

import { AdyenCheckoutMonthlyPaymentForm } from './providers/Adyen';

export const CheckoutMonthlyPaymentForm = params => {
  return <AdyenCheckoutMonthlyPaymentForm {...params} />;
};
